import React from 'react';
import {Navigate, generatePath} from 'react-router-dom';

import Paths from '../../routes/Paths';
import workspaceIdToParam from '../../stores/Workspaces/utils/workspaceIdToParam';
import useStore from '../../stores/useStore';


export const BillingRedirect: React.FC = () => {
  const {activeWorkspace} = useStore();

  if (!activeWorkspace.id) {
    return null;
  }

  return (
    <Navigate
      to={generatePath(Paths.Billing, {
        workspaceId: workspaceIdToParam(activeWorkspace.id),
      })}
    />
  );
};

export default BillingRedirect;